export default "__VITE_ASSET__Brvj6Lf5__"